import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { SEO } from "@/components/SEO";
import { Newspaper } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <SEO title="Editor Login · ITTV News" description="Editor login" />
      <div className="min-h-[70vh] flex items-center container-editorial py-16">
        <div className="w-full max-w-md mx-auto">
          <div className="flex items-center gap-2 mb-8 justify-center">
            <Newspaper className="text-[color:var(--accent)]" size={28} />
            <div className="font-serif text-3xl font-bold">ITTV News</div>
          </div>
          <div className="kicker text-center text-[color:var(--accent)] mb-3">Editor Login</div>
          <h1 className="font-serif text-4xl font-bold text-center leading-tight">Sign in to the newsroom</h1>
          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
            <div>
              <label className="kicker block mb-2">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border px-4 py-3 outline-none" style={{ borderColor: "hsl(var(--border-hsl))" }} data-testid="login-email" />
            </div>
            <div>
              <label className="kicker block mb-2">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border px-4 py-3 outline-none" style={{ borderColor: "hsl(var(--border-hsl))" }} data-testid="login-password" />
            </div>
            <button disabled={busy} className="btn-accent w-full py-4" data-testid="login-submit">{busy ? "Signing in…" : "Sign in"}</button>
          </form>
        </div>
      </div>
    </>
  );
}
